//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    const checkCode = (rule, value, callback) => {
      const reg = /^[A-Za-z-_0-9]{2,50}$/;
      if (!reg.test(value)) {
        return callback(new Error('只能是大小写英文字母、数字以及-_字符，长度为2到50'));
      }
      callback();
    };

    return {
      operation: 'create',
      listData: [],
      count: 0,
      formObj: {},
      appOptions: [],
      oldSearchObj: {},
      searchObj: {
        keyword: this.$route.query.keyword || '',
        appid: Number(this.$route.query.appid) || 0,
        page: Number(this.$route.query.page) || 1,
        page_size: Number(this.$route.query.page_size) || 10,
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入元素名称',
            trigger: 'blur',
          },
        ],
        appid: [
          {
            required: true,
            message: '请选择应用名称',
            trigger: 'change',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入元素Code',
            trigger: 'blur',
          },
          { validator: checkCode, trigger: 'blur' },
        ],
      },
      opDialogVisible: false,
      roleDialogVisible: false,
      submitDisable: false,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        elementManage: this.getElementList.includes('element-manage'),
      };
    },
  },
  async mounted() {
    if (!this.searchObj.appid) {
      this.searchObj.appid = Number(sessionStorage.getItem('app_id'));
    } else {
      sessionStorage.setItem('app_id', this.searchObj.appid);
    }
    await this.loadAppOption();
    if (this.searchObj.appid) {
      this.loadListData();
    }
  },
  methods: {
    searchList() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.oldSearchObj.page && this.oldSearchObj.page === this.searchObj.page) {
        this.searchObj.page = 1;
      }
      this.oldSearchObj = Object.assign({}, this.searchObj);
      this.timer = setTimeout(() => {
        this.$router.push({ query: this.searchObj });
        sessionStorage.setItem('app_id', this.searchObj.appid);
        this.loadListData();
      }, 300);
    },
    resetForm() {
      this.searchObj.keyword = '';
      this.searchList();
    },
    loadListData() {
      const url = this.$api.getElementList;
      const data = this.searchObj;
      const cb = (data) => {
        this.count = data.total;
        this.listData = data.data;
      };
      this.$request({ url, data, cb });
    },
    async loadAppOption() {
      const url = this.$api.getAppList;
      const data = { page_size: 999999 };
      const res = await this.$request({ url, data });
      this.appOptions = res.data;
      this.searchObj.appid = this.searchObj.appid || this.appOptions[0].id;
    },
    submitForm() {
      if (this.submitDisable) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.opDialogVisible = false;
        this.submitDisable = true;
        const { id } = this.formObj;
        const url = id ? this.$api.updateElement : this.$api.createElement;
        const msg = id ? '修改成功' : '创建成功';
        let data = Object.assign({}, this.formObj);
        if (id) {
          data = {
            id,
            name: this.formObj.name,
            code: this.formObj.code,
            description: this.formObj.description,
          };
        }
        const cb = () => {
          this.submitDisable = false;
          this.$message({
            message: msg,
            type: 'success',
          });
          this.loadListData();
        };
        const type = 'post';
        this.$request({ url, data, cb, type });
      });
    },
    deleteOperation(id) {
      const url = this.$api.deleteElement;
      const type = 'post';
      const cb = () => {
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.loadListData();
      };
      this.$request({ url, cb, type, data: { id } });
    },
    handleAdd() {
      this.operation = 'create';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = {
        appid: this.searchObj.appid,
      };
      this.opDialogVisible = true;
    },
    handleEdit(index, data) {
      this.operation = 'update';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = Object.assign({}, data);
      this.opDialogVisible = true;
    },
    handleDelete(index, data) {
      this.$confirm('是否删除该元素?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteOperation(data.id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleCurrentChange(val) {
      this.searchObj.page = val;
      this.searchList();
    },
    handleSizeChange(val) {
      this.searchObj.page = 1;
      this.searchObj.page_size = val;
      this.searchList();
    },
  },
};
